var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { computed, makeObservable, observable, runInAction } from 'mobx';
import { ReservationService } from '@data/api';
const storage = window.sessionStorage;
export default class Reservation {
    constructor() {
        Object.defineProperty(this, "isFetching", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isProcessing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "reservationCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        makeObservable(this);
    }
    clear() {
        runInAction(() => {
            this.model = null;
            this.reservationCode = null;
        });
    }
    clearCreatedReservationId() {
        storage.removeItem('createdReservationId');
    }
    get(reservationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            runInAction(() => {
                this.isFetching = true;
            });
            const result = yield ReservationService.getReservation(reservationCode);
            runInAction(() => {
                this.reservationCode = decodeURIComponent(reservationCode);
                this.model = result;
                this.isFetching = false;
            });
            return this.model;
        });
    }
    handleAfterCreateReservation({ enc_res_id, reservation_id, status, }) {
        runInAction(() => {
            this.isProcessing = false;
            if (!status) {
                return;
            }
            this.reservationCode = enc_res_id;
            storage.setItem('createdReservationId', reservation_id);
        });
    }
    handleBeforeCreateReservation() {
        this.clearCreatedReservationId();
        runInAction(() => {
            this.isProcessing = true;
            this.model = null;
            this.reservationCode = null;
        });
    }
    isReservationJustCreated(reservationId) {
        const storedValue = storage.getItem('createdReservationId');
        return storedValue === reservationId;
    }
    setReservationProcessing(isProcessing) {
        runInAction(() => {
            this.isProcessing = isProcessing;
        });
    }
    get isLoading() {
        return this.isFetching || this.isProcessing;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Reservation.prototype, "isFetching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Reservation.prototype, "isProcessing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Reservation.prototype, "model", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Reservation.prototype, "reservationCode", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Reservation.prototype, "isLoading", null);
